import { makeUrl } from '@app/client';

export const baseURL = makeUrl({ settings: { useSecure: window.location.protocol === 'https:' } });
